export const flags = [{ cultureCode: "sv-SE", flag: "flag-icon flag-icon-se ", languageTag: "navbar.swedish" },
{ cultureCode: "en-GB", flag: "flag-icon flag-icon-gb ", languageTag: "navbar.english" },
{ cultureCode: "da-DK", flag: "flag-icon flag-icon-dk ", languageTag: "navbar.danish" },
{ cultureCode: "nb-NO", flag: "flag-icon flag-icon-no ", languageTag: "navbar.norway" },
{ cultureCode: "pl-PL", flag: "flag-icon flag-icon-pl ", languageTag: "navbar.polish" }];

export const defaultLanguage = "sv-SE";

export const defaultLangPerMarket: Record<string, string> = {
  'se': 'sv-SE',
  'no': 'nb-NO',
  'dk': 'da-DK',
};
